import { ServiceInspectKey } from "./key";
import { useBaseQuery } from "../baseQuery";
import { DocsServiceExternalInspectResponse } from "@maven-rest/docs/Inspect.dto";
import { DocsServiceInspectUrl } from "@maven-rest/docs/Inspect.url";

export function useDocsBeServiceInspectQuery() {
  return useBaseQuery<DocsServiceExternalInspectResponse>({
    queryKey: [ServiceInspectKey.DocsInspect],
    fnOption: { url: DocsServiceInspectUrl.inspect },
    refetchInterval: 1000 * 30,
  });
}
